/* eslint-disable react/no-array-index-key */
import React, { Fragment } from 'react';
import { anyPass, is } from 'ramda';
import PropTypes from 'prop-types';

import { P, A } from './styles';

const Text = ({ isCentered, children }) => (
  <P $isCentered={isCentered}>
    {anyPass([is(String), is(Number)])(children) && children}
    {is(Array, children) &&
      children.map((item, key) => (
        <Fragment key={key}>
          {is(String, item) && item}
          {is(Object, item) && <A href={item.url}>{item.name}</A>}
        </Fragment>
      ))}
  </P>
);

Text.defaultProps = { isCentered: false };
Text.propTypes = {
  isCentered: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
    PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          url: PropTypes.string.isRequired,
        }).isRequired,
      ]).isRequired
    ).isRequired,
  ]).isRequired,
};

export default Text;
